module.exports = __webpack_public_path__ + "img/vertical-logo-strip.81d97670.png";